
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'


//import LightBootstrap from './light-bootstrap-main'


import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'leaflet/dist/leaflet.css';


import { ModalPlugin ,BootstrapVueIcons } from 'bootstrap-vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

//Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

import './registerServiceWorker'
import store from './store'

import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
// Initialize exporting module.
Exporting(Highcharts);
// plugin setup
Vue.use(VueRouter)
//Vue.use(LightBootstrap)
var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo)

// configure router
import router from './routes/routes'

/* eslint-disable no-new */

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
})
